import type { UnwrapNestedRefs } from 'vue';
import { reactive, ref } from 'vue';

import type { UseModal } from '@/utils/useModal/useModal';
import { VGL_ERROR_CODE } from '@/services/errorHandler/errorCodes';

const defaultText =
  'Wir bemühen uns den Fehler schnellst möglich zu beheben! Bitte versuchen Sie er erneut.';

const defaultTitle = 'Ein Problem ist aufgetreten';

const showModal = ref(false);

interface ModalData {
  title: string;
  text: string;
  errorCode: VGL_ERROR_CODE;
  isNonClosableUserModal: boolean;
}

const modalData = reactive<ModalData>({
  title: defaultTitle,
  text: defaultText,
  errorCode: VGL_ERROR_CODE.GENERAL_GENERIC,
  isNonClosableUserModal: false,
});

interface UseErrorModal extends UseModal {
  modalData: UnwrapNestedRefs<ModalData>;
  updateData: (
    errorCode: VGL_ERROR_CODE,
    title?: string,
    text?: string,
    isNonClosableUserModal?: boolean,
  ) => void;
}
export const useErrorModal = (): UseErrorModal => {
  const open = (): void => {
    showModal.value = true;
  };
  const close = (): void => {
    showModal.value = false;
  };

  const updateData = (
    errorCode: VGL_ERROR_CODE,
    title: string = defaultTitle,
    text: string = defaultText,
    isNonClosableUserModal: boolean = false,
  ): void => {
    modalData.errorCode = errorCode;
    modalData.text = text;
    modalData.title = title;
    modalData.isNonClosableUserModal = isNonClosableUserModal;
  };

  return {
    showModal,
    open,
    close,
    modalData,
    updateData,
  };
};
